module.exports = __webpack_public_path__ + "static/media/linkedIn.0e3ed1db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/social/linkedIn.svg
// module id = 608
// module chunks = 0